import { useContext } from "react";
import useSWR from "swr";
import { environment } from "../config/environment";
import { ToastContext } from "../context/ToastContext";
import { useSWRFetcher } from "./useSWRFetcher";
import { UserStyleModel } from "@attelas/shared";

export const useUserStyles = () => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);

  const { data, isLoading, error } = useSWR<UserStyleModel[]>(
    `${environment.apiUrl}/api/users/styles`,
    (url: string) => fetcher(url),
    {
      onError: () => {
        showToast("Failed to get user styles, please try again later", "error");
      },
    }
  );

  return {
    styles: data,
    isLoading,
    isError: !!error,
  };
};
